import * as types from "./actionTypes";

export const setLanguage = (language) => ({
  type: types.SET_LANGUAGE,
  payload: language,
});

export const setFont = (font) => ({
  type: types.SET_FONT,
  payload: font,
});
